import { ButtonSecondary, Icon, Spinner } from '@amelio/ui-library';

import type { User } from '@/types/directory/User';

import { AvatarStack } from '@/components/AvatarStack/AvatarStack';
import { useAmelioTranslations } from '@/hooks';

interface ScheduleCreationHeaderProps {
    reviewees: User[];
    isSavingSchedule: boolean;
    onSaveSettings: () => void;
}

const ScheduleCreationHeader = ({
    reviewees,
    onSaveSettings,
    isSavingSchedule,
}: ScheduleCreationHeaderProps) => {
    const { t } = useAmelioTranslations();
    return (
        <div className={'flex flex-col justify-between gap-4 sm:flex-row sm:items-center md:gap-0'}>
            <AvatarStack
                users={reviewees}
                size={'2xs'}
                spacing={'loose'}
            />

            <ButtonSecondary
                size={'md'}
                onClick={onSaveSettings}
                disabled={isSavingSchedule}
            >
                {isSavingSchedule ? (
                    <Spinner size={'xs'} />
                ) : (
                    <>
                        <Icon
                            name={'settings-setting-2'}
                            className={'mr-2'}
                        />

                        {t('evaluation360ScheduleCreation.header.saveSettings')}
                    </>
                )}
            </ButtonSecondary>
        </div>
    );
};

export { ScheduleCreationHeader };
